import { fork, all } from 'redux-saga/effects';

import * as BRregister from './BRregister';

export default function* rootSaga() {
  yield all([...Object.values(BRregister)].map(fork));
}
